// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"OrderHistory_statusIcon__fzwCz","filterContainer":"OrderHistory_filterContainer__2NMll","filter":"OrderHistory_filter__13HEO"};